import Component from '../../shared/component';
import ClickElement from './click-element';

const SCROLL_TRIGGER_OFFSET = 400;

export default class EventList extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$wrapperElement = $('.eventsWindow-wrapper');
    this.$contentElement = this.$wrapperElement.find('.eventsWindow-content');
    this.$moreButton = $('.eventList-moreTrigger');

    this.isFetchingPreviousEvents = false;
    this.shouldFetchPreviousEvents = true;

    this.bindEvents();
  }

  bindEvents() {
    this.handleScroll = this.handleScroll.bind(this);
    this.handleMoreClick = this.handleMoreClick.bind(this);

    this.$wrapperElement.on('scroll.EventList', this.handleScroll);
    this.$moreButton.on('click', this.handleMoreClick);
  }

  unbindEvents() {
    this.$wrapperElement.off('scroll.EventList', this.handleScroll);
    this.$moreButton.off('click', this.handleMoreClick);

    if (this.clickElements) {
      this.clickElements.forEach((element) => element.unbindEvents());
    }
  }

  fetchPreviousEvents() {
    this.isFetchingPreviousEvents = true;

    const $lastEventElement = this.$element.find('.eventList-item').last();

    if ($lastEventElement.length) {
      const until = $lastEventElement.data('published-at');

      $.get(this.$element.attr('action'), {until}).done((data, code) =>
        this.handlePreviousEventsSuccess(data, code)
      );
    } else {
      this.isFetchingPreviousEvents = false;
    }
  }

  appendPreviousEvents(html) {
    // Wrap new events elements in a uniquely named div
    this.$element.append(html);

    // Initialize ClickElement on newly appended elements
    this.clickElements = ClickElement.initialize(
      this.$element.find('.clickElement')
    );
  }

  hideMoreButton() {
    if (this.$moreButton) {
      this.$moreButton.hide();
    }
  }

  handleMoreClick() {
    if (this.shouldFetchPreviousEvents && !this.isFetchingPreviousEvents) {
      this.fetchPreviousEvents();
    }
  }

  handleScroll() {
    if (this.shouldFetchPreviousEvents && !this.isFetchingPreviousEvents) {
      const scrollPosition =
        this.$wrapperElement.scrollTop() + this.$wrapperElement.height();
      const maxScroll = this.$contentElement.height() - SCROLL_TRIGGER_OFFSET;

      if (scrollPosition > maxScroll) {
        this.fetchPreviousEvents();
      }
    }
  }

  handlePreviousEventsSuccess(data, code) {
    if (code === 'nocontent') {
      this.hideMoreButton();
    } else {
      if (String(data).trim() !== '') {
        this.appendPreviousEvents(data);
      } else {
        // We’ve reached the bottom of the list, stop trying to fetch events
        this.shouldFetchPreviousEvents = false;
      }

      this.isFetchingPreviousEvents = false;
    }
  }
}
